module.exports = __webpack_public_path__ + "static/logo-1057ad005486c9c58b46f104790ffe5e.png";